import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environments';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { IEopDocument, IRecordOfChange, IRecordOfDistribution } from '../models/eopDocument';

@Injectable({
    providedIn: 'root'
})
export class EopDocumentService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getEopDocument(buildingId: string, sectionType: number, subSectionType?: number): Observable<{has_error: boolean, message: string; data: IEopDocument[]}> {
        const url = environment.apiBaseUrl + endpoints.getEopDocument
            .replace(':buildingId', buildingId)
            .replace(':sectionType', String(sectionType))
            + (subSectionType !== undefined && subSectionType !== null ? `?sub_section_type=${subSectionType}` : '');

        return this.http.get<{has_error: boolean, message: string; data: IEopDocument[]}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateEopDocument(buildingId: string, data: IEopDocument, sectionType: number, subSectionType?: number): Observable<{has_error: boolean, message: string, data: any[]}> {
        const url = environment.apiBaseUrl + endpoints.updateEopDocument
            .replace(':buildingId', buildingId)
            .replace(':sectionType', String(sectionType))
            + (subSectionType !== undefined && subSectionType !== null ? `?sub_section_type=${subSectionType}` : '');

        return this.http.post<{has_error: boolean, message: string, data: any[]}>(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }    

    approveEopDocument(buildingId: string, sectionType: number, subSectionType?: number): Observable<{has_error: boolean, message: string, data: any[]}> {
        const url = environment.apiBaseUrl + endpoints.approveEopDocument
            .replace(':buildingId', buildingId)
            .replace(':sectionType', String(sectionType))
            + (subSectionType !== undefined && subSectionType !== null ? `?sub_section_type=${subSectionType}` : '');

        return this.http.put<{has_error: boolean, message: string; data: IEopDocument[]}>(url, {}).pipe(
            catchError(this.errorService.handleError)
        );
    }

    getRecordOfChanges(buildingId: string, schoolYear: string): Observable<IRecordOfChange[]> {
        const url = environment.apiBaseUrl + endpoints.getRecordOfChanges.replace(':buildingId', buildingId);
        
        const params = new HttpParams().set('school_year', schoolYear);

        return this.http.get<IRecordOfChange[]>(url, { params }).pipe(
            catchError(this.errorService.handleError)
        );
    }

    getRecordOfDistribution(buildingId: string, schoolYear: string): Observable<{has_error: boolean, message: string, data: IRecordOfDistribution[]}> {
        const url = environment.apiBaseUrl + endpoints.getRecordOfDistribution.replace(':buildingId', buildingId);
        
        const params = new HttpParams().set('school_year', schoolYear);
        return this.http.get<{has_error: boolean, message: string, data: IRecordOfDistribution[]}>(url, { params }).pipe(
            catchError(this.errorService.handleError)
        );
    }

    downloadEopDocument(buildingId: string, schoolYear: string): Observable<{ has_error: boolean, message: string, data: { filename: string, file_content: string } }> {
        const url = environment.apiBaseUrl + endpoints.downloadEopDocument.replace(':buildingId', buildingId);
        
        const params = new HttpParams().set('school_year', schoolYear);
        return this.http.get<{ has_error: boolean, message: string, data: { filename: string, file_content: string } }>(url, { params }).pipe(
          catchError(this.errorService.handleSavingError)
        );
    }      

    sendEOP(buildingId: string, schoolYear: string, data: IRecordOfDistribution): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.sendEOP.replace(':buildingId', buildingId);
        
        const params = new HttpParams().set('school_year', schoolYear);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data, { params }).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}